import {createContext, useEffect, createElement} from 'external/react'
import { register, registerContext, contexts } from 'external/deep-diff'
import {Spec, useImmutableState} from 'external/immutability-helper'
import useNavigation from 'utilities/navigate'
import { Context, ContextState } from 'types/context/context'

export default function create<T>(id: string, initialState: T, options?: any) {

  const { onInit, onUpdate} = options || {}
  const Context = createContext<Context<T>>(null as unknown as Context<T>)

  Context.displayName = id
  const {Provider, Consumer} = Context
  const result = {
    Context,
    Consumer,
    Provider: (props:any) => {
      const stateWithProps: ContextState<T> = {...initialState, props: props.props}
      const context = useImmutableState(stateWithProps, id)
      registerContext(id, context)
      useEffect(() => { onInit && onInit(context) }, [])
      useEffect(() => { onUpdate && onUpdate(context) }, [context.state])
      useEffect(() => {
        const updateProps = {props: {$set: props.props}} as unknown as Spec<ContextState<T>>
        context.update(updateProps)
      }, [props.props])
      return createElement(Provider, {value: context}, props.children)
    }
  }
  result.Provider['displayName'] = `${id}.State`
  return result
}

export function initializeAndRegisterHooks (id, hooks, resolves) {
  return context => {
    Object.values(resolves).forEach(async resolve => typeof(resolve)== 'function' && await resolve(context, {contexts}))
    hooks.forEach(({paths, resolves}) => register(id, paths, resolves))
  }
}

const composeProviders = props => (Previous, Next) => createElement(Next, {props}, Previous)

export function composeContext (Dep, contextProviders, routes) {
  return props => {
    const routingProps = useNavigation(routes)
    return contextProviders.reduce(composeProviders({...props, ...routingProps}), createElement(Dep, {}, props.children))
  }
}
